import Parkour from 'toxilibs/parkour.js'
import eventBus from 'toxilibs/event_bus_queued.js'
import getUrlParams from 'toxilibs/url_params.js'
import $ from 'jquery'
import applyTransform from './transform.js'
import developmentEnvironment from './development_environment.js'

eventBus.on('player won', function () {
    parkour.completeStep()
})


eventBus.on('challenge selected', function (id) {
    parkour.goTo(id)
})


eventBus.on('user wants to erase all progression', function () {
    parkour.reset()
    eventBus.emit('progression reset')
})


eventBus.on('user wants to restart challenge', function () {
    eventBus.emit('challenge selected', parkour.current.id)
})


if (developmentEnvironment) {
    console.log('DEV : a / z key to navigate through levels')
    $(window).on('keydown', function (event) {
        if (event.key === 'a') {
            let {previous} = parkour //FIXME put this logic in parkour
            if (parkour.previous) {
                eventBus.emit('challenge selected', previous.id)
            }
        }
        if (event.key === 'z') {
            let {next} = parkour
            if (parkour.next) {
                eventBus.emit('challenge selected', next.id)
            }
        }
    })
}



let parkour = new Parkour({
    synchronizer: {
        localStoragePrefix: 'compute_it'
    },
    stepSignature: function (step) {
        return step.id
    },
    onStepCompleted: function (step) {
        eventBus.emit('step completed', step, this.isLastStep(step))
    },
    onStepReached: function (step) {
        let challengeData = step()
        challengeData.id  = step.id
        loadChallenge(challengeData)
    }
})


function loadChallenge (challengeData) {
    applyTransform(challengeData)
    eventBus.emit('challenge loaded', challengeData)
}


let urlParams = getUrlParams()


if (developmentEnvironment) {
    console.log('DEV : use unlocked param to unlock levels')
}

parkour.challengeIsUnlocked = function (challenge) {
    if (developmentEnvironment && 'unlocked' in urlParams) {
        return true
    }

    let previousIndex = this.getStepIndex(challenge) - 1
    let previous      = this.steps[previousIndex]

    return !previous || this.doneSteps[challenge.id] || this.doneSteps[previous.id]
}



export default parkour

